__turbopack_context__.v({
  "contentWrapper": "jrJ6JG_contentWrapper",
  "grammar": "jrJ6JG_grammar",
  "grammarWrapper": "jrJ6JG_grammarWrapper",
  "iconSectionWrapper": "jrJ6JG_iconSectionWrapper",
  "image": "jrJ6JG_image",
  "imageWrapper": "jrJ6JG_imageWrapper",
  "madeBy": "jrJ6JG_madeBy",
  "name": "jrJ6JG_name",
  "pricePerGrammar": "jrJ6JG_pricePerGrammar",
  "productAvailabilityParagraph": "jrJ6JG_productAvailabilityParagraph",
  "trashIcon": "jrJ6JG_trashIcon",
  "wrapper": "jrJ6JG_wrapper",
});
